import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ConsultingService, ExcelService, LoaderService, ReportService} from '@app/shared/services';
import {ActivatedRoute} from '@angular/router';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {FilterPipe} from '@app/shared/pipe';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {UtilsInjectable} from '@app/shared';


@Component({
  selector: 'app-warehouse-stock-log',
  templateUrl: './warehouse-stock-log.component.html',
  styleUrls: ['./warehouse-stock-log.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    FilterPipe,
    SelectDropDownModule,
    PageHeaderComponent,
  ]
})
export class WarehouseStockLogComponent implements OnInit {
  @ViewChild('table') table?: ElementRef;
  user_rights: any;
  user_data: any;
  purchase_data: any;
  closeResult = "";
  medicine: any;
  sale_return_quantity: any;
  sale_quantity = 0;
  fromdate = new Date();
  todate = new Date();
  start: any;
  limit: any;
  total_amount = 0;
  warehouse_id: any;
  warehouse: any;
  warehouse_options: any;
  warehouse_data: any;
  item_id = 0;
  item: any;
  item_options: any;
  item_data: any = [];
  purchase_data_full: any;
  term: any;

  constructor(
    private loaderService: LoaderService,
    private excelService: ExcelService,
    public consultingService: ConsultingService,
    public report: ReportService,
    public utils: UtilsInjectable,
    private route: ActivatedRoute) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.fromdate = new Date(this.fromdate.getFullYear(), this.fromdate.getMonth(), 1, 23, 59, 59);
    this.todate = new Date(this.todate.getFullYear(), this.todate.getMonth() + 1, 0, 23, 59, 59);
    this.route.params.subscribe(params => {
      this.item_id = Number.parseInt(params['itemid']);
      this.getDropdowns();
    });
    this.listPurchaseReport();
    this.getDropdowns();

  }


  public getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  getWarehouse(data: any) {
    this.warehouse_id = data['value'].WAREHOUSE_ID;
  }

  getItem(data: any) {
    this.item_id = data['value'].MEDICINE_ID;
  }

  public getDropdowns() {
    const postData = {
      warehouse_id: '',
      item_id: '',
    };
    this.loaderService.display(true);
    this.consultingService.listWarehouse(postData).subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'Success') {
        this.warehouse = result['data'];
        this.warehouse_options = this.warehouse;
        this.warehouse_options.forEach((element: any) => {
          if (element.WAREHOUSE_ID == this.warehouse_id) {
            this.warehouse_data = element;
          }
        });
      }
    });

    this.consultingService.listMedicine(postData).subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'Success') {
        this.item = result['data'];
        this.item_options = this.item;
        this.item_options.forEach((element: any) => {
          if (element.MEDICINE_ID == this.item_id) {
            this.item_data = element;
          }
        });
      }
    });

    this.setDropdowns();
  }

  public setDropdowns() {
    if (this.warehouse_id) {
      for (let index = 0; index < this.warehouse.length; index++) {
        if (this.warehouse[index].WAREHOUSE_ID == this.warehouse_id) {
          this.warehouse_data = this.warehouse[index];
          break;
        }
      }
    }
  }

  public listPurchaseReport() {
    const postData = {
      invoice_date_from: this.fromdate,
      invoice_date_to: this.todate,
      warehouse_id: this.warehouse_id,
      item_id: this.item_id,
      start: this.start,
      limit: this.limit
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.report.WarehouseStockLog(postData).subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'success') {
        this.purchase_data = result['data'];
        this.purchase_data_full = result['data'];

        const group_to_values = result['data'].reduce(function (obj: any, item: any) {
          obj[item.TRADE_NAME] = obj[item.TRADE_NAME] || [];
          obj[item.TRADE_NAME].push(item);
          return obj;
        }, {});
        this.purchase_data = Object.keys(group_to_values).map(function (key) {
          return {name: key, data: group_to_values[key]};
        });
      } else {
        this.loaderService.display(false);
        this.purchase_data = [];
        this.total_amount = 0;
      }
    });
  }

  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.purchase_data_full, 'Warehouse Stock Log');
  }

}
